module.exports = __webpack_public_path__ + "img/university_1.024af1d7.jpg";